export type AppTheme = "dark" | "light";

export const applyTheme = (theme: unknown) => {
  const isDark = theme === "dark";
  const root = document.documentElement;

  root.classList.toggle("dark", isDark);
  root.classList.toggle("light", !isDark);
};
